import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "./redux/modules/userSlice";
import { useSession } from "./components/AuthBootstrap";

export const PrivateNewJoinee = ({ children }) => {
  const { user } = useSelector(selectUser);
  const { sessionReady } = useSession();

  if (!sessionReady) {
    return null;
  }

  if (!user || !user._id) {
    return <Navigate to="/login" />;
  }

  if (user.isAdmin || user.isSuperAdmin) {
    return <Navigate to="/AdminDashboard" />;
  }

  return children ? children : <Outlet />;
};

export const PrivateAdmin = ({ children }) => {
  const { user } = useSelector(selectUser);
  const { sessionReady } = useSession();

  if (!sessionReady) {
    return null;
  }

  if (!user || !user._id) {
    return <Navigate to="/login" />;
  }

  if (!user.isAdmin && !user.isSuperAdmin) {
    return <Navigate to="/" />;
  }

  return children ? children : <Outlet />;
};
